/**
 * Used to get which part of the string was matched.
 * @param {string} source
 * @param {string} pattern
 * @returns {Array<import("@/jsDocTypes/FrequentAddress").MatchedSubstring>}
 * @param {boolean} caseSensitive
 */
export default function calculateHighlightInfo(source, pattern, caseSensitive = false) {
    const matchedSubstrings = [];
    const patternLength = pattern.length;
    let sourceCopy = source;
    let patternCopy = pattern;
    let offset = 0;
    // not doing a check here causes an infinite loop in the while loop
    if (!source.trim().length || !pattern.trim().length) {
        return matchedSubstrings;
    }
    if (!caseSensitive) {
        sourceCopy = source.toLowerCase();
        patternCopy = pattern.toLowerCase();
    }
    while (sourceCopy.indexOf(patternCopy, offset) !== -1) {
        const start = sourceCopy.indexOf(patternCopy, offset);
        matchedSubstrings.push({
            length: patternLength,
            offset: start
        });
        offset = start + patternLength;
    }
    return matchedSubstrings;
}
